export const TenantId = 'Tenant id';
